import DATE_FORMAT_STRINGS from "../constant/dateFormat";
import { useAppSelector } from "../store";
import dayjs, { Dayjs } from "dayjs";

export const getTimezoneDateWithOffset = ({
  date,
  gmtOffset = 0,
}: {
  date: string | Dayjs;
  gmtOffset: number;
}): Dayjs => {
  // UTC 문자열을 파싱할 때는 명시적으로 UTC임을 알려줌
  const dateObj = dayjs.isDayjs(date) ? date : dayjs.utc(date);
  // gmtOffset에 따라 시간 조정
  if (gmtOffset >= 0) {
    return dateObj.add(gmtOffset, "hour");
  } else {
    return dateObj.subtract(Math.abs(gmtOffset), "hour");
  }
};

export const getFormattedTimezoneDateWithOffset = ({
  date,
  format = DATE_FORMAT_STRINGS.YYYY_MM_DD,
  gmtOffset = 0,
}: {
  date: string | Dayjs;
  format?: string;
  gmtOffset: number;
}): string => {
  return getTimezoneDateWithOffset({ date, gmtOffset }).format(format);
};

export const useCompanyLocalDate = ({
  date,
  format = DATE_FORMAT_STRINGS.YYYY_MM_DD,
}: {
  date: string;
  format?: string;
}): string => {
  const userSession = useAppSelector((state) => state.auth.user);
  const gmtOffset = userSession?.exporter.gmtOffset || 0;

  if (!date) {
    return "-";
  }

  return getFormattedTimezoneDateWithOffset({ date, format, gmtOffset });
};
